module.exports = __webpack_public_path__ + "img/img8.5ab15fdc.png";